import { cx } from '../cx'
import styles from './SkillRow.module.css'

export interface SkillRowProps {
  /** The rung's rating — rendered as a signed badge ("+5"). */
  rating: number
  skills: Array<{ id: number | string; name: string }>
  /** Highlights the rung ember. The apex of the pyramid (spec §4, §5.1). */
  apex?: boolean
  onSkillClick?: (id: number | string) => void
  className?: string | undefined
}

/**
 * Spec §4 "Skill row". Left rating badge, then one pill per skill at that rung,
 * laid out as the FATE pyramid.
 *
 * The rungs and their membership come from the server's `skills` section — this
 * renders one rung and computes nothing about which skills belong on it.
 */
export function SkillRow({ rating, skills, apex = false, onSkillClick, className }: SkillRowProps) {
  const signed = rating >= 0 ? `+${rating}` : `${rating}`

  return (
    <div className={cx(styles.row, className)}>
      <span className={cx(styles.rating, apex && styles.apexRating)}>{signed}</span>
      <div className={styles.skills}>
        {skills.map((skill) =>
          onSkillClick !== undefined ? (
            <button
              key={skill.id}
              type="button"
              onClick={() => onSkillClick(skill.id)}
              className={cx(styles.skill, apex && styles.apexSkill)}
            >
              {skill.name}
            </button>
          ) : (
            <span key={skill.id} className={cx(styles.skill, apex && styles.apexSkill)}>
              {skill.name}
            </span>
          ),
        )}
      </div>
    </div>
  )
}
